export const selectStylesDirectory = (props) => ({
  container: (styles) => ({ ...styles, width: "100%" }),
  control: (styles) => ({
    ...styles,
    color: "#2D3958",
    backgroundColor: "#F7F9FF",
    paddingLeft: "10px",
    paddingRight: "10px",
    borderWidth: 0,
    paddingTop: "6px",
    paddingBottom: "6px",
    borderRadius: 8,
    boxShadow: "none",
    fontSize: "16px",
    fontFamily: "Inter-Regular",
    minWidth: "160px",
    height: "48px",
    cursor: "pointer",
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isFocused
        ? "#F7F9FF !important"
        : isSelected
        ? `#F7F9FF !important`
        : "white !important",
      color: isDisabled ? "#ccc" : "#2D3958",
      cursor: isDisabled ? "not-allowed" : "default",
      fontSize: "16px",
      zIndex: 1,
    };
  },
  input: (styles) => ({ ...styles }),
  valueContainer: (styles) => ({
    ...styles,
    paddingLeft: "0px",
    paddingRight: "0px",
  }),
  placeholder: (styles) => ({
    ...styles,
    color: "#2D3958",
    fontSize: "16px",
  }),
  singleValue: (styles, { data }) => ({ ...styles, color: "#2D3958" }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#2D3958",
    paddingLeft: "0px",
    paddingRight: "0px",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  menu: (styles) => ({
    ...styles,
    borderRadius: 12,
    overflow: "hidden",
  }),
  indicatorSeparator: (styles) => ({ ...styles, display: "none" }),
});

export const selectStyles = {
  control: (styles) => ({
    ...styles,
    color: "#2D3958",
    backgroundColor: "#F7F9FF",
    paddingLeft: "10px",
    paddingRight: "10px",
    borderWidth: 0,
    paddingTop: "6px",
    paddingBottom: "6px",
    borderRadius: 8,
    boxShadow: "none",
    fontSize: "16px",
    fontFamily: "Inter-Regular",
    minWidth: "160px",
    height: "48px",
    cursor: "pointer",
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isFocused
        ? "#F7F9FF !important"
        : isSelected
        ? `#F7F9FF !important`
        : "white !important",
      color: isDisabled ? "#ccc" : "#2D3958",
      cursor: isDisabled ? "not-allowed" : "default",
      fontSize: "16px",
      zIndex: 1,
    };
  },
  input: (styles) => ({ ...styles }),
  valueContainer: (styles) => ({
    ...styles,
    paddingLeft: "0px",
    paddingRight: "0px",
  }),
  placeholder: (styles) => ({
    ...styles,
    color: "#2D3958",
    fontSize: "16px",
  }),
  singleValue: (styles, { data }) => ({ ...styles, color: "#2D3958" }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#2D3958",
    paddingLeft: "0px",
    paddingRight: "0px",
  }),
  menu: (styles) => ({
    ...styles,
    borderRadius: 12,
    overflow: "hidden",
  }),
  indicatorSeparator: (styles) => ({ ...styles, display: "none" }),
};

export const customStyles = ({ height, bgColor }) => ({
  control: (styles) => ({
    ...styles,
    color: "#3A3A3A",
    background: bgColor ? "#f7f9ff" : "#FFFFFF",
    backgroundColor: "#FFFFFF",
    paddingLeft: "10px",
    paddingRight: "10px",
    borderWidth: 1,
    borderColor: "#DEE2E6",
    paddingTop: "6px",
    paddingBottom: "6px",
    borderRadius: 12,
    boxShadow: "none",
    fontSize: "16px",
    fontFamily: "Inter-Regular",
    minWidth: "100%",
    height: "48px",
  }),

  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isFocused
        ? "#F7F9FF !important"
        : isSelected
        ? `#F7F9FF !important`
        : "white !important",
      color: isDisabled ? "#ccc" : "#2D3958",
      cursor: isDisabled ? "not-allowed" : "default",
      fontSize: "16px",
    };
  },
  input: (styles) => ({ ...styles }),
  valueContainer: (styles) => ({
    ...styles,
    paddingLeft: "0px",
    paddingRight: "0px",
  }),
  placeholder: (styles) => ({
    ...styles,
    color: "#2D3958",
    fontSize: "16px",
  }),
  singleValue: (styles, { data }) => ({ ...styles, color: "#3A3A3A" }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#3A3A3A",
  }),
  dropdownIndicator: (styles) => ({
    paddingLeft: "0px",
    paddingRight: "0px",
  }),
  indicatorSeparator: (styles) => ({ ...styles, display: "none" }),
  menuPortal: (styles) => ({ ...styles, zIndex: 9999 }),
  menu: (styles) => ({
    ...styles,
    // maxHeight: height ? height : "200px",
    overflowY: "auto",
  }),
});

export const customStylesSubsidy = ({
  noBorder,
  preferences,
  bgWhite,
  isDisabled,
}) => ({
  control: (styles) => ({
    ...styles,
    color: bgWhite ? "#566985" : "#3A3A3A",
    background: isDisabled ? "#EFEFEF4D" : bgWhite ? "#FFFFFF" : "#F7F9FF",
    backgroundColor: isDisabled ? "#EFEFEF4D" : bgWhite ? "#FFFFFF" : "#F7F9FF",
    paddingLeft: "10px",
    paddingRight: "10px",
    borderWidth: noBorder ? 0 : 1, // Conditionally remove the border
    borderColor: bgWhite || noBorder ? "transparent" : "#DEE2E6",
    paddingTop: "6px",
    paddingBottom: "6px",
    borderRadius: bgWhite ? "6px" : "12px",
    boxShadow: "none",
    fontSize: "14px",
    fontFamily: "Inter-Regular",
    minWidth: "100%",
    height: "48px",
    "&:hover": {
      borderColor: "transparent",
    },
  }),

  option: (styles, { isDisabled, isFocused, isSelected }) => {
    const focusedColor = preferences ? "#DEE2E6" : "#F7F9FF";
    const selectedColor = preferences ? "#DEE2E6" : "#F7F9FF";

    return {
      ...styles,
      backgroundColor: isFocused
        ? `${focusedColor} !important`
        : isSelected
        ? `${selectedColor} !important`
        : "white !important",
      color: isDisabled ? "#ccc" : bgWhite ? "#566985" : "#2D3958",
      cursor: isDisabled ? "not-allowed" : "default",
      fontSize: "16px",
    };
  },
  input: (styles) => ({ ...styles }),
  valueContainer: (styles) => ({
    ...styles,
    paddingLeft: "0px",
    paddingRight: "0px",
  }),
  placeholder: (styles) => ({
    ...styles,
    color: bgWhite ? "#566985" : "#2D3958",
    fontSize: "16px",
    fontFamily: bgWhite ? "Inter-Medium" : "Inter-Regular",
  }),
  singleValue: (styles, { data }) => ({
    ...styles,
    color: bgWhite ? "#566985" : "#3A3A3A",
    fontFamily: bgWhite ? "Inter-Medium" : "Inter-Regular",
    fontSize: bgWhite ? "16px" : "14px",
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    color: "#3A3A3A",
    paddingLeft: "0px",
    paddingRight: "0px",
  }),
  indicatorSeparator: (styles) => ({ ...styles, display: "none" }),
});

export const enableScroll = () => {
  const htmlTag = document.querySelector("html");
  htmlTag.classList.remove("disable-scroll");
  htmlTag.classList.add("enable-scroll");
};
